function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 13.382V3.88h2v9.511l2.021-2.021 1.415 1.414-3.018 3.017.002.002-1.414 1.415-.002-.002-.002.002-1.414-1.415.002-.002-3.018-3.017 1.415-1.414L11 13.382zm-8 4.74h18v2H3v-2z",
  fill: "#16191C",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;